export default "__VITE_PUBLIC_ASSET__545725ee__"